exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._18VAb{height:24px;margin-left:12px;margin-bottom:16px;padding-bottom:8px;border-bottom:1px solid #d3d3d3}._2Cnwx{font-weight:400;font-size:.75em;color:red;margin-left:16px}", ""]);

// exports
exports.locals = {
	"form": "_18VAb",
	"warning": "_2Cnwx"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"module":true,"modules":true,"localIdentName":"[hash:base64:5]"}!../node_modules/sass-loader/lib/loader.js?{"outputStyle":"collapsed","sourceMap":true,"includePaths":["/Users/markromero/Code/frn-platform-frontend/src"]}!./routes/Checkout/components/BraintreeForm/styles.scss
// module id = 1119
// module chunks = 0